import React from 'react';
import { Link } from 'react-router-dom';
import noParkings from '../assets/JSON-Gifs/GIF/3.404.json';
import LottieGIF from '../components/lottieComponent';

// Centered in the viewport; the animation used to sit in the top-left corner
// because nothing positioned its wrapper.
export default function NotFound() {
  return (
    <div
      className="d-flex flex-column justify-content-center align-items-center text-center"
      style={{ minHeight: '100vh' }}
    >
      <LottieGIF json={noParkings} loop={true} height="15rem" width="15rem" />
      <p className="mt-3 mb-2">The page you are looking for does not exist.</p>
      <Link to="/">Go to dashboard</Link>
    </div>
  );
}
